import { MockSocketService } from '@/shared/mocks/MockSocketService';
import { SocketService } from './SocketService';
import type { ISocketService } from './types';

const IS_MOCK =
  process.env.NODE_ENV === 'development' &&
  process.env.NEXT_PUBLIC_MOCK_ENABLED === 'true';

/**
 * msw에서 사용하는 socket.io는 shared worker에서 실행되지 않고 main thread에서 실행되기 때문에
 * 별도의 MockSocketService를 생성한다.
 */

export const socketInstance: ISocketService = IS_MOCK
  ? MockSocketService.getInstance()
  : SocketService.getInstance();
